var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    viewBox: "0 0 512 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 352 384 L 416 384 L 352 384 L 416 384 Q 430 384 439 375 Q 448 366 448 352 L 448 96 L 448 96 Q 448 82 439 73 Q 430 64 416 64 L 352 64 L 352 64 Q 338 64 329 55 Q 320 46 320 32 Q 320 18 329 9 Q 338 0 352 0 L 416 0 L 416 0 Q 457 1 484 28 Q 511 55 512 96 L 512 352 L 512 352 Q 511 393 484 420 Q 457 447 416 448 L 352 448 L 352 448 Q 338 448 329 439 Q 320 430 320 416 Q 320 402 329 393 Q 338 384 352 384 L 352 384 Z M 134 374 L 11 251 L 134 374 L 11 251 Q 0 240 0 224 Q 0 208 11 197 L 134 74 L 134 74 Q 144 64 158 64 Q 172 64 182 74 Q 192 84 192 98 L 192 160 L 192 160 L 320 160 L 320 160 Q 334 160 343 169 Q 352 178 352 192 L 352 256 L 352 256 Q 352 270 343 279 Q 334 288 320 288 L 192 288 L 192 288 L 192 350 L 192 350 Q 192 364 182 374 Q 172 384 158 384 Q 144 384 134 374 L 134 374 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.177781150426d1f6de6c02752c459c20.svg";
export { ForwardRef as ReactComponent };